import { camelCase } from '@cc-shopping/utils/string/camelCase';
import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

export const getDriverRegularApr = (
  marketplaceEntity: MarketplaceEntity,
): MarketplaceDriverConfig | null => {
  if (!marketplaceEntity.driverRegularApr) return null;
  return {
    id: camelCase(marketplaceEntity.driverRegularApr.label),
    label: marketplaceEntity.driverRegularApr.label,
    value: marketplaceEntity.driverRegularApr.value,
    description: undefined,
    labelTooltip: undefined,
    valueTooltip: marketplaceEntity.driverRegularApr.valueTooltip,
    valueTooltipHasHtml: false,
  };
};
